export default "__VITE_ASSET__BKRiqs1H__"